import { useCallback, useState } from 'react';

export const useSummaryTask = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleOnChange = useCallback((e, tab) => {
    setActiveTab(tab);
  }, []);

  return { activeTab, handleOnChange };
};
